import { useEffect, useState } from "react";
import {
  ButtonPasswordIcon,
  CloseButtonModel,
  ContainerInput,
  ErrorTextUser,
  SubmitFormButton,
  TextInput,
} from "../SignUpModel/SignUpModelStyles.styled";
import { FormErrorsSignIn } from "../TypeErrors";
import {
  SignInButtonForgotPassword,
  SignInForgotPasswordContainer,
  SignInHeader,
  SignInListItem,
  SignInModelContainer,
  SignInTitle,
} from "./SignInModelStyles.styled";
import { logIn } from "../../../../../Redux/Auth/operations";
import { CloseButtonIcon, EmailUserIcon } from "../SignUpModel/setPublicIcons";
import { useAppDispatch } from "../../../../../Redux/store";
import { useNavigate } from "react-router-dom";
import { useTogglePassword } from "../../../../secure/PasswordHook";
import { useLanguageContext } from "../../../../Languages/Langs/LanguageContext";

interface SignInModelProps {
  onClose: () => void;
  onForgotPassword?: () => void;
}

// fix error, if user not already signed up with (nameuser) []
// make optimization after sign up user (delay 2s) []
// add reCAPTCHA []

export const SignInModel: React.FC<SignInModelProps> = ({
  onClose,
  onForgotPassword,
}) => {
  const { t } = useLanguageContext();
  const [emailUserSignIn, setEmailUserSignIn] = useState(() => {
    const saved = localStorage.getItem("form-data-signIn");
    return saved ? JSON.parse(saved).email || "" : "";
  });

  const [passwordUser, setPasswordUser] = useState("");

  const [formErrorsSignInModel, setFormErrorsSignInModel] =
    useState<FormErrorsSignIn>({});
  const [hasTriedSubmit, setHasTriedSubmit] = useState(false);
  const dispatch = useAppDispatch();

  const enterPassword = useTogglePassword();
  const router = useNavigate();

  const SignInUser = async (evt: React.FormEvent<HTMLFormElement>) => {
    evt.preventDefault();
    setHasTriedSubmit(true);

    try {
      const resultAction = await dispatch(
        logIn({ email: emailUserSignIn, password: passwordUser })
      ).unwrap();

      const loggedUserName = resultAction.name?.toLowerCase();

      // ✅ Передаємо стан для відкриття QR модалки
      router(`/home-page/${loggedUserName}`, {
        state: { openQRCodeModal: true },
      });

      onClose();
      clearLocalStorage("form-data-signIn");
    } catch (err: unknown) {
      console.log("Unwrapped error:", err);

      if (typeof err === "object" && err !== null) {
        const typedError = err as FormErrorsSignIn & { general?: string };

        // Якщо це проблема з email → показуємо під email
        if (typedError.email) {
          setFormErrorsSignInModel({
            email: typedError.email,
            password: "",
          });
          return;
        }

        // Якщо це проблема з password → показуємо під password
        if (typedError.password) {
          setFormErrorsSignInModel({
            email: "",
            password: typedError.password,
          });
          return;
        }

        // Якщо сервер повернув загальну помилку
        if (typedError.general) {
          const msg = typedError.general.toLowerCase();

          if (msg.includes("password")) {
            setFormErrorsSignInModel({
              email: "",
              password: typedError.general,
            });
          } else if (msg.includes("email")) {
            setFormErrorsSignInModel({
              email: typedError.general,
              password: "",
            });
          } else {
            // fallback якщо сервер віддав непонятну general
            setFormErrorsSignInModel({
              email: "",
              password: typedError.general,
            });
          }
        }
      }
    }
  };

  const clearLocalStorage = (nameKey: string) => {
    localStorage.removeItem(nameKey);
  };

  useEffect(() => {
    const formDataUser = {
      email: emailUserSignIn.trim(),
    };

    localStorage.setItem("form-data-signIn", JSON.stringify(formDataUser));

    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflowY = "scroll";
    };
  }, [emailUserSignIn, onClose]);

  return (
    <>
      <SignInModelContainer>
        <SignInHeader>
          <SignInTitle>
            {t("publicTranslate.FormsAndModel.ModelSignIn.Title")}
          </SignInTitle>
          <CloseButtonModel type="button" onClick={onClose}>
            <CloseButtonIcon />
          </CloseButtonModel>
        </SignInHeader>

        <form onSubmit={SignInUser}>
          <ul>
            <SignInListItem>
              <ContainerInput
                className={
                  formErrorsSignInModel.email && hasTriedSubmit
                    ? "error-animation-input"
                    : ""
                }
              >
                <TextInput
                  name="email"
                  type="email"
                  placeholder={t(
                    "publicTranslate.FormsAndModel.ModelSignIn.InputEmail"
                  )}
                  onChange={(evt) => {
                    const value = evt.target.value;
                    setEmailUserSignIn(value);
                    setFormErrorsSignInModel((prev) => ({
                      ...prev,
                      email: value ? "" : prev.email,
                    }));
                  }}
                  value={emailUserSignIn}
                />
                <EmailUserIcon />
              </ContainerInput>
              <ErrorTextUser
                className={
                  formErrorsSignInModel.email && hasTriedSubmit
                    ? "error-animation"
                    : ""
                }
              >
                {formErrorsSignInModel.email}
              </ErrorTextUser>
            </SignInListItem>
            <SignInListItem>
              <ContainerInput
                className={
                  formErrorsSignInModel.password && hasTriedSubmit
                    ? "error-animation-input"
                    : ""
                }
              >
                <TextInput
                  name="password"
                  type={enterPassword.type}
                  placeholder={t(
                    "publicTranslate.FormsAndModel.ModelSignIn.InputPassword"
                  )}
                  onChange={(evt) => {
                    const value = evt.target.value;
                    setPasswordUser(value);
                    setFormErrorsSignInModel((prev) => ({
                      ...prev,
                      password: value ? "" : prev.password,
                    }));
                  }}
                  value={passwordUser}
                />
                <ButtonPasswordIcon
                  type="button"
                  onClick={enterPassword.toggle}
                >
                  {enterPassword.icon}
                </ButtonPasswordIcon>
              </ContainerInput>
              <ErrorTextUser
                className={
                  formErrorsSignInModel.password && hasTriedSubmit
                    ? "error-animation"
                    : ""
                }
              >
                {formErrorsSignInModel.password}
              </ErrorTextUser>
            </SignInListItem>
          </ul>
          <SignInForgotPasswordContainer>
            <SignInButtonForgotPassword
              type="button"
              onClick={onForgotPassword}
            >
              {t(
                "publicTranslate.FormsAndModel.ModelSignIn.ButtonForgotPassword"
              )}
            </SignInButtonForgotPassword>
          </SignInForgotPasswordContainer>

          <SubmitFormButton
            type="submit"
            value={t("publicTranslate.FormsAndModel.ModelSignIn.ButtonSignIn")}
          />
        </form>
      </SignInModelContainer>
    </>
  );
};
